import { Component, OnInit, ViewChild } from '@angular/core';
import { DynamicFormServiceService } from 'src/app/shared/services/dynamic-form-service.service';
import {
  UntypedFormGroup,
  UntypedFormArray,
  UntypedFormControl
} from '@angular/forms';
import { Option } from 'src/app/core/interfaces/options-dynamicform';
import { OrderFieldConfig } from 'src/app/core/classes/orderFieldConfig';
import { Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, startWith } from 'rxjs/operators';
import { BroadcastService } from '../../services/broadcast.service';
import { MatAutocompleteTrigger  } from '@angular/material/autocomplete';
import { Constants } from '../../constants';
@Component({
    selector: 'app-checkbox-form',
    templateUrl: './checkbox-form.component.html',
    styleUrls: ['./checkbox-form.component.scss'],
    standalone: false
})
export class OrderCheckboxFormComponent implements OnInit {

  field: OrderFieldConfig;
  group: UntypedFormGroup;
  isRequired: boolean;
  toggleCheck: boolean;
  currentControlName: any;
  sortedOptions = [];
  selectAndSearchForCheckBox = new UntypedFormControl('');
  filteredCheckBoxValues = new  Observable<string[]>();
  allCheckBoxValues: string[] = [];
  noData: boolean;
  isRequiredField: boolean;
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;
  constructor(
    private dynamicService: DynamicFormServiceService,
    public broadcastService: BroadcastService) {}
    
  ngOnInit() {
    this.sortedOptions = this.field.options;
    this.isRequired = this.dynamicService.checkHasRequired(this.field);
    if (this.isRequired) { 
      this.getFromArray.setValidators(this.checkboxAtLeastOneSelected); 
      this.isRequiredField = true;
    }
    setTimeout(() => this.selectAndSearch(), 0);
    this.broadcastService.subscribe().subscribe((message) => {
      if (message.type === Constants.CLOSE_MAT_AUTOCOMPLETE) {
        this.closeMatAutocomplete();
      }
    });
  }
  
  selectAndSearch() {
    this.sortedOptions.forEach((x, i) => {
      // tslint:disable-next-line: triple-equals
      if (this.getFromArray.at(i).value == x.code) {
        x.isFromKeyboardSelected = true;
      } else {
        x.isFromKeyboardSelected = false;
      }
      this.allCheckBoxValues.push(x.value);
    });
    this.selectAndSearchForCheckBox.valueChanges
        .pipe(
            startWith(''),
            debounceTime(500),
            distinctUntilChanged()
          )
          .subscribe((searchVal: string) => {
            if (searchVal) {
              this.filteredCheckBoxValues = of(this._filterCodeValues(searchVal));
            } else {
              this.noData = false;
              this.filteredCheckBoxValues = of(this.allCheckBoxValues.slice());
            }
          });
  }

  _filterCodeValues(value: string) {
    const word = value.toLowerCase().trim();
    let acc: string[] = [];
    const val = this.allCheckBoxValues.filter(o =>
      Object.keys(o).some(k => (o).toLowerCase().includes(word)));
    acc = acc.concat(val).filter((v, i, a) => a.indexOf(v) === i);
    this.noData = acc.length <= 0;
    return acc;
  }

  get getFromArray(): UntypedFormArray {
    return this.group.get(this.field.labelCode) as UntypedFormArray;
  }

  setCheckBoxValue(event, value: Option, controlName) {
    const so = this.sortedOptions.find(x => x.code === value.code)
    if (event.checked) {
      this.getFromArray.at(controlName).setValue(value.code);
      so.isFromKeyboardSelected = true;
      this.isRequiredField = false;
    } else {
      this.getFromArray.at(controlName).setValue(null);
      so.isFromKeyboardSelected = false;
      if(this.isRequired){
        const anyChecked = this.sortedOptions.some(opt => opt.isFromKeyboardSelected);
        this.isRequiredField = !anyChecked;
      }
      
    }
  }

  private checkboxAtLeastOneSelected(form: UntypedFormGroup) {
    return Object.keys(form.controls)
            .some(control => form.controls[control].value !== false && form.controls[control].value !== null) ? null : { invalidCheckboxes: true };
  }

  checkBoxSelectionChanged(event: any) {
    this.sortedOptions.forEach((x, i) => {
      if (x.value === event.option.value) {
        if (x.isFromKeyboardSelected) {
          x.isFromKeyboardSelected = false;
          this.getFromArray.at(i).setValue(null);
          if(this.isRequired){
            const anyChecked = this.sortedOptions.some(opt => opt.isFromKeyboardSelected);
            this.isRequiredField = !anyChecked;
          }
        } else {
          this.getFromArray.at(i).setValue(x.code);
          x.isFromKeyboardSelected = true;
          this.isRequiredField = false;
        }
      }
    });
    this.clearFieldOnBackSpace();
}

clearFieldOnBackSpace() {
  this.selectAndSearchForCheckBox.reset();
}

closeMatAutocomplete() {
  this.autocomplete.closePanel();
}
}
